<template>
  <v-btn
      @click="initReadingStatus"
      :prepend-icon="mdiUndo"
      size="x-small"
      variant="text"
  >{{ $t('mission-planning.qst.status.cancel') }}</v-btn>
</template>

<script setup>
import {mdiUndo} from "@mdi/js";
import {READING} from '@/constants';
import { useStoreManager } from '@/stores/storeManager';

const props = defineProps(['reading']);
const storeManager = useStoreManager();
const initReadingStatus = () => {
  props.reading.status = READING.STATUS.NEW;
  storeManager.update('reading', 'reading', props.reading.id, props.reading);
}

</script>
